import moment from 'moment-timezone';

/**
 * Whether the user should be asked to choose between "this session" and
 * "this and following sessions". The backend treats any edit that changes a
 * series session's date as "this session only", so the question is skipped
 * whenever the calendar date (in `tz`) changes.
 */
export const shouldAskSeriesScope = ({
    oldStart,
    newStart,
    isInSeries,
    tz,
}: {
    oldStart: Date | string;
    newStart: Date | string;
    isInSeries: boolean;
    tz?: string;
}): boolean => {
    if (!isInSeries) return false;

    const zone = tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const day = (d: Date | string) =>
        moment.tz(new Date(d), zone).format('YYYY-MM-DD');

    return day(oldStart) === day(newStart);
};
